import { render } from "./NumberOneIcon.vue?vue&type=template&id=2259e758"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/NumberOneIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2259e758"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2259e758', __exports__)) {
    api.reload('2259e758', __exports__)
  }
  
  module.hot.accept("./NumberOneIcon.vue?vue&type=template&id=2259e758", () => {
    api.rerender('2259e758', render)
  })

}


export default __exports__